<template>
  <section
    class="principal-section"
    :style="backgroundStyle"
    :class="`layout-${layout}`"
  >
    <div class="section-container">
      <div v-if="mediaType && mediaSrc" class="media-container">
        <video
          v-if="mediaType === 'video'"
          class="section-media"
          autoplay
          muted
          loop
          playsinline
          disablepictureinpicture
          controlslist="nodownload nofullscreen noremoteplayback"
        >
          <source :src="mediaSrc" type="video/mp4" />
        </video>

        <img
          v-else-if="mediaType === 'image'"
          class="section-media"
          :src="mediaSrc"
          :alt="mediaAlt"
          loading="lazy"
        />
      </div>

      <div class="content-container">
        <p v-if="title" class="section-title">{{ title }}</p>

        <p v-if="text" class="section-text" v-html="text"></p>

        <GenericButton
          v-if="buttonText"
          :text="buttonText"
          :backgroundColor="buttonBackground"
          :textColor="buttonTextColor"
          :shadowType="buttonShadow"
          @click="$emit('button-click')"
        />
      </div>
    </div>
  </section>
</template>

<script>
import GenericButton from "../../../components/commons/controls/GenericButton.vue";

export default {
  name: "PrincipalSection",

  components: {
    GenericButton,
  },

  props: {
    overlayColor: {
      type: String,
      default: "var(--violet)",
      validator: (value) =>
        [
          "var(--violet)",
          "var(--dark-blue)",
          "var(--purple)",
          "var(--green)",
          "var(--light-blue)",
          "var(--yellow)",
        ].includes(value),
    },

    backgroundImage: {
      type: String,
      default: "assets/backgrounds/BackgroundImage.png",
    },

    layout: {
      type: String,
      default: "media-left",
      validator: (value) => ["media-left", "media-right"].includes(value),
    },

    mediaType: {
      type: String,
      default: "",
      validator: (value) => ["", "video", "image"].includes(value),
    },

    mediaSrc: {
      type: String,
      default: "",
    },

    mediaPoster: {
      type: String,
      default: "",
    },

    mediaAlt: {
      type: String,
      default: "Imagen descriptiva",
    },

    title: {
      type: String,
      default: "",
    },

    text: {
      type: String,
      default: "",
    },

    buttonText: {
      type: String,
      default: "",
    },

    buttonBackground: {
      type: String,
      default: "var(--white)",
    },

    buttonTextColor: {
      type: String,
      default: "var(--violet)",
    },

    buttonShadow: {
      type: String,
      default: "light",
      validator: (value) => ["light", "dark"].includes(value),
    },
  },

  computed: {
    backgroundStyle() {
      const colorMap = {
        "var(--violet)": "70, 37, 79",
        "var(--dark-blue)": "7, 60, 93",
        "var(--purple)": "116, 66, 83",
        "var(--green)": "31, 122, 140",
        "var(--light-blue)": "81, 152, 211",
        "var(--yellow)": "211, 175, 74",
        "var(--black)": "20, 20, 20",
      };

      const rgb = colorMap[this.overlayColor] || "70, 37, 79";

      return {
        background: `linear-gradient(
          rgba(${rgb}, 0.95),
          rgba(${rgb}, 0.95)
        ), url('${this.backgroundImage}')`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      };
    },
  },

  emits: ["button-click"],
};
</script>

<style scoped lang="scss">
@import "src/ux/layout/styles/principalSectionStyle";
</style>